export const LANG = {
  en: {
    about: {
      title: "About Us",
      desc: "We are a platform dedicated to exploring and implementing low-level design concepts through practical React Proof-of-Concepts (POCs).",
      whatWeDo:
        "Our website focuses on providing hands-on learning through React-based POCs. We develop modular, scalable solutions to help developers understand the core principles of low-level design, including component design, state management, and performance optimization.",
      mission:
        "Our mission is to bridge the gap between theoretical concepts and practical implementation by offering simple yet effective POCs. Whether you're a beginner or an experienced developer, our platform is designed to enhance your understanding of low-level design in React projects.",
      descriptionTitle: "Project Description",
      whatWeDoTitle: "What We Offer",
      missionTitle: "Our Mission",
    },
    contact: {
      title: "Contact Us",
      desc: "We'd love to hear from you!",
      nameLabel: "Name:",
      emailLabel: "Email:",
      messageLabel: "Message:",
      submitButton: "Submit",
    },
    login: {
      title: "Login",
      emailLabel: "Email:",
      passwordLabel: "Password:",
      submitButton: "Submit",
    },
  },
  hi: {
    about: {
      title: "हमारे बारे में",
      desc: "हम व्यावहारिक React प्रमाण अवधारणाओं (POCs) के माध्यम से निम्न-स्तरीय डिज़ाइन अवधारणाओं का अन्वेषण और कार्यान्वयन करने के लिए एक प्लेटफ़ॉर्म हैं।",
      whatWeDo:
        "हमारी वेबसाइट व्यावहारिक सीखने पर केंद्रित है, जो React आधारित POCs के माध्यम से सीखने के अनुभव को और बेहतर बनाती है। हम निम्न-स्तरीय डिज़ाइन के मुख्य सिद्धांतों को समझने के लिए मॉड्यूलर और स्केलेबल समाधान विकसित करते हैं, जिसमें घटक डिज़ाइन, राज्य प्रबंधन और प्रदर्शन अनुकूलन शामिल हैं।",
      mission:
        "हमारा मिशन सैद्धांतिक अवधारणाओं और व्यावहारिक कार्यान्वयन के बीच की खाई को पाटना है, सरल और प्रभावी POCs के माध्यम से। चाहे आप एक शुरुआती हों या एक अनुभवी डेवलपर, हमारा प्लेटफार्म आपके React परियोजनाओं में निम्न-स्तरीय डिज़ाइन को बेहतर ढंग से समझने के लिए बनाया गया है।",
      descriptionTitle: "परियोजना का विवरण",
      whatWeDoTitle: "हम क्या पेशकश करते हैं",
      missionTitle: "हमारा मिशन",
    },
    contact: {
      title: "हमसे संपर्क करें",
      desc: "हम आपसे सुनना चाहेंगे!",
      nameLabel: "नाम:",
      emailLabel: "ईमेल:",
      messageLabel: "संदेश:",
      submitButton: "भेजें",
    },
    login: {
      title: "लॉगिन",
      emailLabel: "ईमेल:",
      passwordLabel: "पासवर्ड:",
      submitButton: "जमा करें",
    },
  },
  sp: {
    about: {
      title: "Acerca de nosotros",
      desc: "Somos una plataforma dedicada a explorar y aplicar conceptos de diseño de bajo nivel a través de pruebas de concepto (POCs) prácticas en React.",
      whatWeDo:
        "Nuestro sitio web se enfoca en el aprendizaje práctico a través de POCs basados en React. Desarrollamos soluciones modulares y escalables para ayudar a los desarrolladores a comprender los principios fundamentales del diseño de bajo nivel, incluidos el diseño de componentes, la gestión del estado y la optimización del rendimiento.",
      mission:
        "Nuestra misión es cerrar la brecha entre los conceptos teóricos y la implementación práctica ofreciendo POCs simples pero efectivos. Ya seas un principiante o un desarrollador experimentado, nuestra plataforma está diseñada para mejorar tu comprensión del diseño de bajo nivel en proyectos React.",
      descriptionTitle: "Descripción del Proyecto",
      whatWeDoTitle: "Lo que ofrecemos",
      missionTitle: "Nuestra Misión",
    },
    contact: {
      title: "Contáctenos",
      desc: "¡Nos encantaría saber de ti!",
      nameLabel: "Nombre:",
      emailLabel: "Correo electrónico:",
      messageLabel: "Mensaje:",
      submitButton: "Enviar",
    },
    login: {
      title: "Iniciar sesión",
      emailLabel: "Correo electrónico:",
      passwordLabel: "Contraseña:",
      submitButton: "Enviar",
    },
  },
};
